import React, { useState } from "react";
import { useSelector } from "react-redux";
import { View, Flex, Card, Divider, Heading, Text, Radio, Expander, ExpanderItem } from '@aws-amplify/ui-react';
import Menue from './Menue';

import { KompList, getKE, Empfehlung, GroupColors, MyCheckBoxField, StatelessRadioGroupField, StatelessCheckBoxField, Emoji } from '../lib';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function getKomponentenAusMenues(menueID, menueListe) {
    const theMenue = menueListe.filter(f => f.ID === parseInt(menueID));
    if (!theMenue || theMenue.length === 0) return [];
    const theKomps = theMenue.map(m => m.KOMPONENTEN);
    if (!theKomps || theKomps.length === 0) return [];
    const retVal = theKomps[0].map(k => `${k.ID}`);
    // console.log('IDs:', retVal)

    return retVal;
}

const getAllergeneUndZusatzstoffe = (alluZusList, allergene, zusatzstoffe) => {
    // console.log('alluZusList, allergene, zusatzstoffe', alluZusList, allergene, zusatzstoffe)
    const all = alluZusList.map(e => {
        const allergen = allergene.filter(f => f.ID === e)[0];
        return allergen ? `${allergen.ID} = ${allergen.BEZEICHNUNG}` : '';
    });
    // console.log('Allergen:', all)
    const zus = alluZusList.map(e => {
        const zusatzstoff = zusatzstoffe.filter(f => f.ID === e)[0];
        return zusatzstoff ? `${zusatzstoff.ID} = ${zusatzstoff.BEZEICHNUNG}` : '';
    });
    return all.concat(zus).filter(e => e !== '');
}

/*
const filterAllergeneUndZusatzstoffe = (AllergeneUndZusatzstoffe, tags) => {
    let arr = []
    tags.forEach(element => {
        arr = arr.concat(AllergeneUndZusatzstoffe.filter(item => (item.startsWith('(' + element + ')') || item.startsWith(element + ' ='))))
    })
    return arr
}
*/


const TheDay = (props) => {
    const [showAllergeneUndZusatzstoffe, setShowAllergeneUndZusatzstoffe] = useState(false)
    const daten = useSelector(state => state.menueWahl);
    const menueGruppen = useSelector(state => state.menues ? state.menues.MENUEGRUPPEN : state.menues);
    const komponenten = useSelector(state => state.menues ? state.menues.MENUEKOMPONENTEN : undefined);
    const alleMenues = useSelector(state => state.menues ? state.menues.MENUES : state.menues);
    const allergene = useSelector(state => state.menues ? state.menues.ALLERGENE : state.menues);
    const zusatzstoffe = useSelector(state => state.menues ? state.menues.ZUSATZSTOFFE : state.menues);
    const showTheStuff = false;
    const [togoState, setToGoState] = useState(parseInt(daten.ToGo[props.outer_index].WAHL));
    const [beilageState, setBeilageState] = useState(/^\d+$/.test(daten.Sonstiges[props.outer_index].WAHL) ? parseInt(daten.Sonstiges[props.outer_index].WAHL) : daten.Sonstiges[props.outer_index].WAHL);
    const [menueState, setMenueState] = useState(/^\d+$/.test(daten.MenueWahl[props.outer_index].WAHL) ? parseInt(daten.MenueWahl[props.outer_index].WAHL) : daten.MenueWahl[props.outer_index].WAHL);

    function isNumber(a) { return /^\d$/.test(a) }

    function sortTheList(liste) {
        const theArr = liste.split(',');
        const sortedArr = theArr.sort((a, b) => {
            if (isNumber(a[0]) && !isNumber(b[0])) return 1;
            if (!isNumber(a[0]) && isNumber(b[0])) return -1;
            return a.localeCompare(b)
        });
        const sortedArray = [...new Set(sortedArr)]; // make it unique
        return sortedArray.join(',')
    }

    const getHiddenFromMenue = (theMenue) => {
        const pictogramme = [];
        const allergene = [];
        theMenue.KOMPONENTEN.forEach((item) => {
            const komp = komponenten.filter(f => f.ID === item.ID && item.SHOW === 0)
            if (komp.length > 0) {
                komp.forEach(item => {
                    if (item.ALLERGENEUNDZUSATZ > '')
                        allergene.push(item.ALLERGENEUNDZUSATZ)
                    if (item.PICTOGRAMME > '')
                        pictogramme.push(item.PICTOGRAMME)
                })
            }
        })
        const pictStr = pictogramme.join('+');
        const allergStr = allergene.join(',');
        // console.log('MenueList::theMenue, hidden', theMenue, pictStr, allergStr)
        return { PICTOGRAMME: pictStr, ALLERGENEUNDZUSATZ: sortTheList(allergStr) };
    }

    const dateOptions = { month: '2-digit', day: '2-digit' }

    if (!props.theDay) return null;  // do not move behind menuesToday

    const menuesToday = props.theDay.MENUELISTE ? props.theDay.MENUELISTE.split(',') : [];
    const komponentenAusMenues = menuesToday.map(e => { return getKomponentenAusMenues(e, alleMenues) }).flat();
    const komponentenToday = props.theDay.KOMPLISTE ? props.theDay.KOMPLISTE.split(',') : [];
    const alleKomponenten = [...new Set([...komponentenAusMenues, ...komponentenToday])]; // join without duplicates
    const alleAllergeneUndZusatzstoffe = komponenten ? alleKomponenten.map(e => komponenten.filter(f => f.ID === parseInt(e))[0] ? komponenten.filter(f => f.ID === parseInt(e))[0].ALLERGENEUNDZUSATZ.split(',') : []).flat().filter(f => f !== '') : [];
    const reducedAllergenUndZusatzstoffe = [...new Set(alleAllergeneUndZusatzstoffe)];
    const AllergeneUndZusatzstoffe = getAllergeneUndZusatzstoffe(reducedAllergenUndZusatzstoffe, allergene, zusatzstoffe)

    if (menuesToday.length === 0) return null;

    const allmenues = menuesToday.map((item, index) => {
        const theMenu = alleMenues.filter(f => f.ID === parseInt(item))[0];
        if (!theMenu) return null;
        const hiddenKomp = getHiddenFromMenue(theMenu);
        const ChoosedColor = menueGruppen.filter(e => theMenu.GRUPPE === e.ID)[0].COLOR || GroupColors[parseInt(theMenu.GRUPPE) % GroupColors.length];
        const { KE, KCAL } = getKE(theMenu.KOMPONENTEN, komponenten);
        const theMenuCard = (<Card style={{ minWidth: "100%", textAlign: "center" }}
            key={`card1_ ${index}`}
            rowSpan={{ base: 2, large: 2 }}
            backgroundColor={ChoosedColor}
        >
            <Menue
                menue={item}
                index={index}
                outer_index={props.outer_index}
                lines={props.menuListLines}
                key={`Menue_${index}`}
                showAllergeneUndZusatzstoffe={showAllergeneUndZusatzstoffe}
            />
        </Card>);
        // console.log('Abendessen', daten.Abendessen[props.outer_index].WAHL)
        return (
            <Flex key={`BaseView_${index}`} style={{ minWidth: "100%" }} direction='column' gap="0.5rem">
                <View style={{ minWidth: "100%", display: 'flex', justifyContent: 'flex-start' }}
                    backgroundColor={ChoosedColor}
                    key={`View_${index}`}
                >
                    <Radio
                        key={`Radio_1_${index}`}
                        value={index + 1}
                        isDisabled={props.disabled}
                    >
                        <Heading
                            key={`Menue1_Header_${index}`}
                            level={5}
                        >&nbsp;{theMenu.ID === props.theDay.EMPFEHLUNG ? <><Empfehlung color='yellow' key={`fce-${index}`} />&nbsp;</> : ''}{theMenu ? theMenu.BEZEICHNUNG : 'Menü ' + index}
                            {showAllergeneUndZusatzstoffe && (hiddenKomp.ALLERGENEUNDZUSATZ > '') && <sup key={`sup_${index}`}>
                                {hiddenKomp.ALLERGENEUNDZUSATZ}</sup>}
                            &nbsp;<Emoji key={`Emo_1_${index}`} symbol={hiddenKomp.PICTOGRAMME} />
                        </Heading>
                    </Radio>
                </View>
                {(KE > 0 || KCAL > 0) ?
                    <OverlayTrigger key={`card_body_ovl_MENUE_${index}`} placement='top' delay={{ show: 400, hide: 400 }} overlay={
                        <Tooltip className="blueTooltip" id={`tooltip-${index}`} key={`TT_1_${index}`}>{`KE: ${KE}, kCal: ${KCAL}`}</Tooltip>
                    }>
                        {theMenuCard}
                    </OverlayTrigger>
                    :
                    <>{theMenuCard}</>

                }
                <Divider key={`divide_3-${index}`} />
            </Flex>
        )
    });

    const handleBeilageChange = (e) => {
        // console.log(menueState)
        if (menueState === '0' || menueState === 0)
            setBeilageState(0);
        else
            setBeilageState(/^\d+$/.test(e.target.value) ? parseInt(e.target.value) : e.target.value);
        props.handleChange(e);
    }

    const handleMenueChange = (e) => {
        setMenueState(/^\d+$/.test(e.target.value) ? parseInt(e.target.value) : e.target.value);
        handleChange(e);
    }

    const handleToGoChange = (e) => {
        // console.log(e.target.checked)
        if (menueState === '0' || menueState === 0)
            setToGoState(0);
        else
            setToGoState(e.target.checked ? 1 : 0)
        props.handleChange(e);
    }

    const handleChange = (e) => {
        // console.log(e.target.name, val, index)
        if (e.target.name.startsWith('Mittagessen') && e.target.value === '0') {
            // console.log('found', e.target.name, val, index, daten)
            setToGoState(0)
            setBeilageState(0)
            //daten.Sonstiges[index].WAHL = '';
        }
        /*        funktioniert so nicht, ToDo anders probieren
        */
        props.handleChange(e)
    }

    return (
        <Card
            rowSpan={{ base: 1, large: 2 }}
            backgroundColor="var(--amplify-colors-blue-10)"
            opacity='0.9'>
            {props.disabled && (
                <Text fontSize="small">
                    Heute wählt unser Küchenchef für Sie.
                </Text>
            )}
            <Heading
                level={4}
            >{props.item.Day} {props.theDate.toLocaleString("de-DE", dateOptions)}</Heading>
            {props.istMitarbeiter && false && <>
                <Divider />
                <MyCheckBoxField
                    Name='Frühstück'
                    index={props.outer_index}
                    value={daten.Fruehstueck[props.outer_index].WAHL}
                    handleChange={props.handleChange}
                />
                <Divider />
            </>
            }
            <StatelessRadioGroupField
                Name="Mittagessen"
                index={props.outer_index}
                handleChange={handleMenueChange}
                value={menueState}
            >
                {allmenues}
                {props.theDay.KOMPLISTE > '' &&
                    <KompList list={props.theDay.KOMPLISTE} day={props.outer_index} lines={props.kompListLines}
                        showAllergeneUndZusatzstoffe={showAllergeneUndZusatzstoffe} istMitarbeiter={props.istMitarbeiter}
                        handleChange={handleBeilageChange} beilageState={beilageState}
                    />
                }
                <Expander type="single" isCollapsible={true}
                    style={{
                        backgroundColor: 'var(--amplify-colors-yellow-10)'
                    }}
                    onChange={setShowAllergeneUndZusatzstoffe}
                >
                    <ExpanderItem title="Allergene, Zusatzstoffe" value={true} >
                        {AllergeneUndZusatzstoffe.map((auz, i) => <Text width={220} key={`auz_${i}`} >{auz}</Text>)}
                    </ExpanderItem>

                </Expander>
                {props.istMitarbeiter && <>
                    {showTheStuff && <>
                        <Radio value={10} >Suppe</Radio>
                        <Radio value={11} >Salat</Radio>
                    </>
                    }
                    <Radio value={0} >kein Mittagessen</Radio>
                </>
                }
            </StatelessRadioGroupField>
            {props.istMitarbeiter &&
                <>
                    <StatelessCheckBoxField
                        Name='To Go'
                        index={props.outer_index}
                        value={togoState}
                        handleChange={handleToGoChange}
                    />
                    {showTheStuff && <>
                        <Divider />
                        <MyCheckBoxField
                            Name='Abendessen'
                            index={props.outer_index}
                            value={daten.Abendessen[props.outer_index].WAHL}
                            handleChange={props.handleChange}
                        />
                    </>
                    }
                </>
            }
        </ Card>
    )

}

export default TheDay;